import { Breadcrumbs } from "@mui/material"
import { MouseEvent } from "react"
import { ReactComponent as NextIcon } from '../../assets/Icons/chevron/Chevron-Right.svg';

export default function PageBreadcrumbs ({
    pages,
}: {
    pages: {
        label: string,
        action?: (e: MouseEvent<HTMLButtonElement>) => void,
    }[],
}) {
    return (
        <Breadcrumbs
            separator={<div className="w-[14px] text-disable"><NextIcon/></div>}
            sx={{
                fontFamily: 'Montserrat',
            }}
        >
            {pages.map((page,i) => {
                if (page.action) {
                    return (
                        <button 
                            key={i}
                            onClick={page.action} 
                            className=" text-[14px] font-medium text-disable hover:text-primary transition-all"
                        >
                            {page.label}
                        </button>
                    )
                } else {
                    return (
                        <p key={i} className="text-default font-medium text-[14px]">{page.label}</p>
                    )
                }
            })}
        </Breadcrumbs>
    )
}